import BandIcon from '@mui/icons-material/MusicNote';
import BookIcon from '@mui/icons-material/AutoStories';
import CableIcon from '@mui/icons-material/MicExternalOn';
import CallIcon from '@mui/icons-material/AddCall';
import CameraIcon from '@mui/icons-material/SportsEsports';
import CateringIcon from '@mui/icons-material/Flatware';
import CheckroomIcon from '@mui/icons-material/Checkroom';
import ChildrenIcon from '@mui/icons-material/ChildFriendly';
import CoffeeIcon from '@mui/icons-material/Coffee';
import ConstructionIcon from '@mui/icons-material/Construction';
import CountertopsIcon from '@mui/icons-material/Countertops';
import DecorationIcon from '@mui/icons-material/ColorLens';
import DefaultIcon from '@mui/icons-material/Groups';
import DiningIcon from '@mui/icons-material/LocalDining';
import DollarIcon from '@mui/icons-material/AttachMoney';
import EuroIcon from '@mui/icons-material/Euro';
import FamilyIcon from '@mui/icons-material/FamilyRestroom';
import FoodIcon from '@mui/icons-material/Fastfood';
import ForkliftIcon from '@mui/icons-material/Forklift';
import HeartIcon from '@mui/icons-material/Favorite';
import KeyIcon from '@mui/icons-material/Key';
import LightIcon from '@mui/icons-material/EmojiObjects';
import LiquorIcon from '@mui/icons-material/Liquor';
import MealIcon from '@mui/icons-material/SetMeal';
import MicIcon from '@mui/icons-material/Mic';
import ModeratorIcon from '@mui/icons-material/Person';
import OrganizingIcon from '@mui/icons-material/ContentPaste';
import PastoringIcon from '@mui/icons-material/MedicalServices';
import PianoIcon from '@mui/icons-material/Piano';
import PodcastsIcon from '@mui/icons-material/Podcasts';
import PreacherIcon from '@mui/icons-material/Church';
import SanitizerIcon from '@mui/icons-material/Sanitizer';
import SavingsIcon from '@mui/icons-material/Savings';
import SecurityIcon from '@mui/icons-material/Security';
import ShoppingIcon from '@mui/icons-material/ShoppingCart';
import ShoppingBagIcon from '@mui/icons-material/ShoppingBag';
import ShoppingBasketIcon from '@mui/icons-material/ShoppingBasket';
import SoundIcon from '@mui/icons-material/Headphones';
import StageIcon from '@mui/icons-material/Chair';
import StarIcon from '@mui/icons-material/Star';
import StreamIcon from '@mui/icons-material/YouTube';
import TableIcon from '@mui/icons-material/TableBar';
import TheaterComedyIcon from '@mui/icons-material/TheaterComedy';
import VideoIcon from '@mui/icons-material/OndemandVideo';
import VolunteerIcon from '@mui/icons-material/VolunteerActivism';
import WelcomeIcon from '@mui/icons-material/WavingHand';

// Custom SVG Icons
import BarIcon from '@/assets/icons/Bar.svg?react';
import BassIcon from '@/assets/icons/Bass.svg?react';
import BibleIcon from '@/assets/icons/Bible.svg?react';
import CrossIcon from '@/assets/icons/Cross.svg?react';
import DishesIcon from '@/assets/icons/Dishes.svg?react';
import DishWashIcon from '@/assets/icons/DishWash.svg?react';
import DrumsticksIcon from '@/assets/icons/Drumsticks.svg?react';
import GuitarIcon from '@/assets/icons/Guitar.svg?react';
import PercussionIcon from '@/assets/icons/Percussion.svg?react';
import PrayIcon from '@/assets/icons/Pray.svg?react';

export const CATEGORY_ICONS = [
    'Euro',
    'band',
    'bar',
    'bass',
    'bible',
    'book',
    'cable',
    'call',
    'camera',
    'category',
    'catering',
    'checkroom',
    'children',
    'coffee',
    'construction',
    'countertops',
    'cross',
    'decoration',
    'dining',
    'dishes',
    'dishwash',
    'dollar',
    'drumsticks',
    'family',
    'food',
    'forklift',
    'guitar',
    'heart',
    'key',
    'light',
    'liquor',
    'meal',
    'mic',
    'moderator',
    'organizing',
    'pastoring',
    'piano',
    'percussion',
    'podcast',
    'pray',
    'preacher',
    'sanitizer',
    'savings',
    'security',
    'shopping',
    'shoppingbag',
    'shoppingbasket',
    'sound',
    'stage',
    'star',
    'stream',
    'table',
    'theater',
    'video',
    'volunteer',
    'welcome',
];

interface CategoryIconProps {
    category: (typeof CATEGORY_ICONS)[number];
    size?: string;
}

const CategoryIcon = ({ category, size = '20px' }: CategoryIconProps) => {
    switch (category) {
        case 'Euro':
            return <EuroIcon sx={{ fontSize: size }} />;
        case 'band':
            return <BandIcon sx={{ fontSize: size }} />;
        case 'bar':
            return <BarIcon height={size} width={size} style={{ objectFit: 'contain' }} />;
        case 'bass':
            return <BassIcon height={size} width={size} style={{ objectFit: 'contain' }} />;
        case 'bible':
            return <BibleIcon height={size} width={size} style={{ objectFit: 'contain' }} />;
        case 'book':
            return <BookIcon sx={{ fontSize: size }} />;
        case 'cable':
            return <CableIcon sx={{ fontSize: size }} />;
        case 'call':
            return <CallIcon sx={{ fontSize: size }} />;
        case 'camera':
            return <CameraIcon sx={{ fontSize: size }} />;
        case 'catering':
            return <CateringIcon sx={{ fontSize: size }} />;
        case 'checkroom':
            return <CheckroomIcon sx={{ fontSize: size }} />;
        case 'children':
            return <ChildrenIcon sx={{ fontSize: size }} />;
        case 'coffee':
            return <CoffeeIcon sx={{ fontSize: size }} />;
        case 'construction':
            return <ConstructionIcon sx={{ fontSize: size }} />;
        case 'countertops':
            return <CountertopsIcon sx={{ fontSize: size }} />;
        case 'cross':
            return <CrossIcon height={size} width={size} style={{ objectFit: 'contain' }} />;
        case 'decoration':
            return <DecorationIcon sx={{ fontSize: size }} />;
        case 'dining':
            return <DiningIcon sx={{ fontSize: size }} />;
        case 'dishes':
            return <DishesIcon height={size} width={size} style={{ objectFit: 'contain' }} />;
        case 'dishwash':
            return <DishWashIcon height={size} width={size} style={{ objectFit: 'contain' }} />;
        case 'dollar':
            return <DollarIcon sx={{ fontSize: size }} />;
        case 'drumsticks':
            return <DrumsticksIcon height={size} width={size} style={{ objectFit: 'contain' }} />;
        case 'family':
            return <FamilyIcon sx={{ fontSize: size }} />;
        case 'food':
            return <FoodIcon sx={{ fontSize: size }} />;
        case 'forklift':
            return <ForkliftIcon sx={{ fontSize: size }} />;
        case 'guitar':
            return <GuitarIcon height={size} width={size} style={{ objectFit: 'contain' }} />;
        case 'heart':
            return <HeartIcon sx={{ fontSize: size }} />;
        case 'key':
            return <KeyIcon sx={{ fontSize: size }} />;
        case 'light':
            return <LightIcon sx={{ fontSize: size }} />;
        case 'liquor':
            return <LiquorIcon sx={{ fontSize: size }} />;
        case 'meal':
            return <MealIcon sx={{ fontSize: size }} />;
        case 'mic':
            return <MicIcon sx={{ fontSize: size }} />;
        case 'moderator':
            return <ModeratorIcon sx={{ fontSize: size }} />;
        case 'organizing':
            return <OrganizingIcon sx={{ fontSize: size }} />;
        case 'pastoring':
            return <PastoringIcon sx={{ fontSize: size }} />;
        case 'piano':
            return <PianoIcon sx={{ fontSize: size }} />;
        case 'percussion':
            return <PercussionIcon height={size} width={size} style={{ objectFit: 'contain' }} />;
        case 'podcast':
            return <PodcastsIcon sx={{ fontSize: size }} />;
        case 'pray':
            return <PrayIcon height={size} width={size} style={{ objectFit: 'contain' }} />;
        case 'preacher':
            return <PreacherIcon sx={{ fontSize: size }} />;
        case 'sanitizer':
            return <SanitizerIcon sx={{ fontSize: size }} />;
        case 'savings':
            return <SavingsIcon sx={{ fontSize: size }} />;
        case 'security':
            return <SecurityIcon sx={{ fontSize: size }} />;
        case 'shopping':
            return <ShoppingIcon sx={{ fontSize: size }} />;
        case 'shoppingbag':
            return <ShoppingBagIcon sx={{ fontSize: size }} />;
        case 'shoppingbasket':
            return <ShoppingBasketIcon sx={{ fontSize: size }} />;
        case 'sound':
            return <SoundIcon sx={{ fontSize: size }} />;
        case 'stage':
            return <StageIcon sx={{ fontSize: size }} />;
        case 'star':
            return <StarIcon sx={{ fontSize: size }} />;
        case 'stream':
            return <StreamIcon sx={{ fontSize: size }} />;
        case 'table':
            return <TableIcon sx={{ fontSize: size }} />;
        case 'theater':
            return <TheaterComedyIcon sx={{ fontSize: size }} />;
        case 'video':
            return <VideoIcon sx={{ fontSize: size }} />;
        case 'volunteer':
            return <VolunteerIcon sx={{ fontSize: size }} />;
        case 'welcome':
            return <WelcomeIcon sx={{ fontSize: size }} />;
    }

    return <DefaultIcon sx={{ fontSize: size }} />;
};

export default CategoryIcon;
